import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    tglStock: Yup.string().required("Pilih tanggal"),
    idUnitProduksi: Yup.string().required("Pilih unit produksi"),
    idGudang: Yup.string().required("Pilih gudang"),
  });
